import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authService, updateApiClientTokens, clearApiClientTokens } from '../services/auth';

interface User {
  id: string;
  phone: string;
  email?: string;
  role: string;
  locale: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: false,
  error: null,
};

export const requestOtp = createAsyncThunk(
  'auth/requestOtp',
  async ({ phone }: { phone: string }) => {
    const response = await authService.requestOtp(phone);
    return (response as any).data;
  }
);

export const login = createAsyncThunk(
  'auth/login',
  async ({ phone, code }: { phone: string; code: string }) => {
    const response = await authService.verifyOtp(phone, code);
    return (response as any).data;
  }
);

export const getProfile = createAsyncThunk(
  'auth/getProfile',
  async () => {
    const response = await authService.getProfile();
    return (response as any).data;
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.payload.accessToken;
        state.isAuthenticated = true;
        localStorage.setItem('token', action.payload.accessToken);
        localStorage.setItem('refreshToken', action.payload.refreshToken);
        
        // Mettre à jour les tokens dans l'ApiClient
        updateApiClientTokens(action.payload.accessToken, action.payload.refreshToken);
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Erreur de connexion';
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.user = action.payload;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        
        // Nettoyer les tokens dans l'ApiClient
        clearApiClientTokens();
      });
  },
});

export const { clearError } = authSlice.actions;
export default authSlice.reducer;
